import { useState } from 'react'
import './PaymentMethodSelector.scss'
import useAPI from '../../hooks/useAPI'

const CheckIcon = () => (
  <svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M41.2002 2.14355V28.4814H0.799805V2.14355H41.2002ZM33.7656 25.7373H38.4561V21.0469L33.7656 25.7373ZM8.23145 25.7373H29.0811V16.3623H38.4561V4.8877H8.23145V25.7373ZM3.54395 25.7373H5.4873V4.8877H3.54395V25.7373ZM31.8252 23.7969L36.5156 19.1064H31.8252V23.7969Z"
      fill="#313131" stroke="#313131" strokeWidth="0.4"/>
    <path
      d="M38.8564 30.4248V32.7686H41.2002V35.5127H38.8564V37.8564H4.51562C2.46665 37.8564 0.799805 36.1896 0.799805 34.1406C0.799805 32.0917 2.46665 30.4248 4.51562 30.4248H38.8564ZM4.51562 33.1689C3.97991 33.1689 3.54395 33.6049 3.54395 34.1406C3.54395 34.6763 3.97991 35.1123 4.51562 35.1123H10.1748V33.1689H4.51562ZM12.9189 35.1123H34.4248V33.1689H12.9189V35.1123ZM36.5127 11.5186V14.2627H10.1748V11.5186H36.5127ZM23.5439 6.83105V9.5752H10.1748V6.83105H23.5439Z"
      fill="#313131" stroke="#313131" strokeWidth="0.4"/>
  </svg>
)

const PlaidIcon = () => (
  <svg width="108" height="40" viewBox="0 0 108 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_105)">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M52.3521 20.9753H50.8074V17.5332H52.1954C53.8823 17.5332 54.726 18.1109 54.726 19.2651C54.726 20.4055 53.9349 20.9753 52.3521 20.9753ZM56.6302 15.3053C55.7342 14.5699 54.2039 14.2027 52.0389 14.2027H47.1567V28.9173H50.8074V24.307H52.442C54.4279 24.307 55.8837 23.8801 56.809 23.0264C57.8535 22.0711 58.3768 20.7993 58.3768 19.2101C58.3768 17.563 57.795 16.2616 56.6302 15.3053ZM64.6254 14.2021H60.818V28.9178H69.038V25.5863H64.6257L64.6254 14.2021ZM76.4503 23.7997L78.0181 18.7696L79.5628 23.7997H76.4503ZM76.4947 14.2021L70.5155 28.9178H74.6138L75.3978 26.7782H80.5931L81.3094 28.9178H85.454L79.5183 14.2021H76.4947ZM87.357 28.9178H91.1644V14.2021H87.357V28.9178ZM99.8539 25.5865H98.2186V17.5332H99.8762C101.041 17.5332 101.936 17.8882 102.563 18.5973C103.191 19.3073 103.504 20.3135 103.504 21.6142C103.504 24.263 102.287 25.5865 99.8539 25.5865ZM105.945 16.9598C105.438 16.2533 104.833 15.6879 104.132 15.2611C102.982 14.5546 101.414 14.2013 99.4279 14.2013H94.4114V28.9169H100.279C102.399 28.9169 104.102 28.2413 105.386 26.8879C106.67 25.5346 107.311 23.7405 107.311 21.5045C107.311 19.7251 106.856 18.2106 105.945 16.9598Z"
            fill="#313131"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M36.135 36.8361L39.2727 24.5888L35.0216 20.3378L39.2726 16.0865L36.1348 3.83898L23.8875 0.701286L19.6365 4.95256L15.3851 0.701483L3.13769 3.83937L0 16.0865L4.25167 20.3375L0.000196364 24.5889L3.13789 36.8363L15.3852 39.974L19.6365 35.7227L23.8876 39.9739L36.135 36.8361ZM22.0658 33.2936L26.1144 29.2448L31.2656 34.3963L24.8198 36.0477L22.0658 33.2936ZM15.5879 13.8598L19.6368 9.81118L23.6854 13.8596L19.6365 17.9082L15.5879 13.8598ZM17.2073 20.3377L13.1585 24.3862L9.1099 20.3377L13.1585 16.2891L17.2073 20.3377ZM26.1145 16.2888L30.1633 20.3377L26.1144 24.3862L22.0658 20.3377L26.1145 16.2888ZM23.6852 26.8157L19.6365 30.8643L15.5878 26.8155L19.6365 22.7668L23.6852 26.8157ZM14.4529 36.0477L8.00692 34.3963L13.1585 29.2447L17.2073 33.2936L14.4529 36.0477ZM6.68068 22.7668L10.7293 26.8155L5.57771 31.9671L3.92629 25.5212L6.68068 22.7668ZM5.57771 8.70782L10.7295 13.8596L6.68068 17.9085L3.92629 15.1538L5.57771 8.70782ZM17.2075 7.38177L13.1587 11.4306L8.00732 6.279L14.4533 4.62758L17.2075 7.38177ZM24.8202 4.62758L31.266 6.279L26.1144 11.4304L22.0658 7.38177L24.8202 4.62758ZM32.5924 17.9085L28.5436 13.8596L33.695 8.70841L35.3464 15.1545L32.5924 17.9085ZM33.695 31.9671L28.5436 26.8157L32.5924 22.7671L35.3464 25.5212L33.695 31.9671Z"
            fill="#313131"/>
    </g>
    <defs>
      <clipPath id="clip0_1_105">
        <rect width="108" height="40" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)

const ShieldIcon = () => (
  <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.5 0L0.5 4V10C0.5 15.55 4.34 20.74 9.5 22C14.66 20.74 18.5 15.55 18.5 10V4L9.5 0ZM9.5 6C10.9 6 12.3 7.1 12.3 8.5V10C12.9 10 13.5 10.6 13.5 11.3V14.8C13.5 15.4 12.9 16 12.2 16H6.7C6.1 16 5.5 15.4 5.5 14.7V11.2C5.5 10.6 6.1 10 6.7 10V8.5C6.7 7.1 8.1 6 9.5 6ZM9.5 7.2C8.7 7.2 8 7.7 8 8.5V10H11V8.5C11 7.7 10.3 7.2 9.5 7.2Z"
      fill="#315C1C"/>
  </svg>
)

const SelectedCheckmark = () => (
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 2L6 14L0.5 8.5L1.91 7.09L6 11.17L16.59 0.589996L18 2Z" fill="white"/>
  </svg>
)

const PaymentMethodSelector = ({ setPaymentMethodStateParam }) => {
  const api = useAPI()
  const [selected, setSelected] = useState('CHECK')
  const [savingPaymentSettings, setSavingPaymentSettings] = useState(false)

  const methods = [
    {
      id: 'CHECK',
      label: 'Check',
      description: 'Receive payment by check',
      icon: <CheckIcon/>,
    },
    {
      id: 'ACH',
      label: 'ACH (Plaid)',
      description: 'Secure Bank Payment',
      icon: <PlaidIcon/>,
    },
  ]

  const savePaymentSettings = async () => {
    if (!selected) {
      alert('Please select a payment method first.')
      return
    }

    try {
      setSavingPaymentSettings(true)

      const response = await api.put('/payment-methods/settings', {
        method: selected,
      })

      if (response.status !== 200) {
        throw new Error('Failed to save settings. Please try again.')
      }
      setPaymentMethodStateParam(selected)
    } catch (error) {
      alert(error.message || 'Something went wrong.')
    } finally {
      setSavingPaymentSettings(false)
    }
  }

  return (
    <div className="payment-container">
      <h2 className="payment-title">Select Payment Method</h2>

      <div className="payment-options">
        {methods.map((method) => (
          <button
            key={method.id}
            onClick={() => setSelected(method.id)}
            className={`payment-option ${selected === method.id ? 'selected' : ''}`}
          >
            {method.icon}
            <span className="payment-label">{method.label}</span>
            <span className="payment-description">{method.description}</span>
            {selected === method.id && (
              <div className="checkmark">
                <SelectedCheckmark/>
              </div>
            )}
          </button>
        ))}
      </div>

      <div className="ssl-badge">
        <div className="ssl-shield">
          <ShieldIcon/>
        </div>
        <div className="ssl-text">
          <span className="ssl-title">SSL-SECURE CONNECTION</span>
          <span className="ssl-subtitle">100% secured payment</span>
        </div>
      </div>

      <div className="default-payment-information">
        If you choose Plaid, your payment method will be set to ACH. Please go to Payment settings if you would like to change that. Note: CSG never stores customer information. Please see more here: <a href="https://plaid.com/safety/" target="_blank" rel="noreferrer">https://plaid.com/safety</a>
      </div>

      <button className="payment-continue"
              onClick={savePaymentSettings}
              disabled={savingPaymentSettings}
      >
        {savingPaymentSettings ? 'Saving...' : 'Continue'}
      </button>
    </div>
  )
}

export default PaymentMethodSelector
